import * as React from 'react';
const SvgAgriculture = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={960} height={960} viewBox='0 0 75 75' {...props}>
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={5.76}
      d='M1.475 51.767c-2.185 3.293-.218-8.588.279-12.508C3.55 25.087 6.046 16.072 17.988 7.425c3.915-2.836 28.188-11.628 30.784-5.016C61.942 35.964 23.298 51.255 0 51.255'
      transform='matrix(-.56937 .03986 .03986 .56937 70.261 28.135)'
    />
    <path
      fill={props.stroke || 'tan'}
      fillRule='evenodd'
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={0.8218944}
      d='m65.793 50.545-2.155-5.777-2.761-4.223-3.645-2.712-4.263-1.598-3.174-.395-2.24-.028 2.936 1.222 5.459 3.156 3.471 2.86 2.51 3.093 2.287 2.922 1.604 2.464'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={5.76}
      d='M1.475 51.767c-2.185 3.293-.218-8.588.279-12.508C3.55 25.087 6.046 16.072 17.988 7.425c3.915-2.836 28.188-11.628 30.784-5.016C61.942 35.964 23.298 51.255 0 51.255'
      transform='matrix(.56937 .03986 -.03986 .56937 8.041 27.72)'
    />
    <path
      fill={props.stroke || 'tan'}
      fillRule='evenodd'
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={0.8218944}
      d='m12.51 50.13 2.154-5.776 2.762-4.224 3.644-2.711 4.263-1.598 3.175-.396 2.24-.028-2.937 1.222-5.458 3.157-3.472 2.858-2.51 3.095-2.287 2.921-1.604 2.464'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={5.76}
      d='M1.475 51.767c-2.185 3.293-.218-8.588.279-12.508C3.55 25.087 6.046 16.072 17.988 7.425c3.915-2.836 28.188-11.628 30.784-5.016C61.942 35.964 23.298 51.255 0 51.255'
      transform='matrix(.42685 .3789 -.3789 .42685 38.15 -4.355)'
    />
    <path
      fill={props.stroke || 'tan'}
      fillRule='evenodd'
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.44}
      d='m0 28.371 2.924-10.398 4.21-7.775 5.969-5.264 7.211-3.408L25.8.374 29.707 0l-4.95 2.56-9.073 6.304-5.646 5.495-3.935 5.767-3.568 5.432-2.443 4.536'
      transform='matrix(.42188 .38444 -.38444 .42188 38.928 4.158)'
    />
  </svg>
);
export default SvgAgriculture;
